// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Bh","linkButtonFrame":"Bi","linkButton":"Bj","navLinkWhileSearching":"Bk"};